import { useContextSelector } from 'use-context-selector';
import { UserStateContext } from '../../context/UserContext/UserContext';

export const useUserState = () => {
  const context = useContextSelector(UserStateContext, (v) => v);
  if (context === undefined)
    throw new Error('useUserState must be used within a UserProvider');
  return context;
};
